import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from '../../../utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class BranchMaintenanceService {

  constructor(
    private http: HttpService,
  ) { }
    
  getList(data?: any) {
    return this.http.post(Path.BRANCH.GET_LIST, data);
  }
  
  getDetail(params?: any) {
    return this.http.get(Path.BRANCH.GET_DETAIL, params);
  }
  
  insert(data?: any) {
    return this.http.post(Path.BRANCH.INSERT, data);
  }

  genericMaintenanceDownload(data?: any) {
    return this.http.post(Path.DOWNLOAD.DOWNLOAD_BRANCH_MAINTENACE, data);
  }
}